import  { useEffect, useState  } from 'react';
import { useNavigate  } from 'react-router-dom';
import { MailOutlined, LockOutlined , EyeOutlined, EyeInvisibleOutlined  } from '@ant-design/icons';
import {  Button } from 'antd';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
import ForgotPasswordModal from '../modals/ForgotPasswordModal';
import illustration from '../utils/assets/backconfirm.png';
import Logo from '../utils/assets/login-illustration.png'

const LoginPage = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({ Email: '', Password: '' });
  const [touched, setTouched] = useState({ Email: false, Password: false });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
   
   const token = localStorage.getItem('token');
   const role = localStorage.getItem('role');
    useEffect(() => {
      if(token != null) {
        navigate('/')
      } 

   

      
    }, []);

  const isEmailValid = /\S+@\S+\.\S+/.test(form.Email);
  const isPasswordValid = form.Password.length >= 6;

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleBlur = (e) => {
    setTouched({ ...touched, [e.target.name]: true });
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/user/login`, form);
      // console.log(response);
      
      if (response.data.success) {  
        localStorage.setItem('tempToken', response.data.token); // Save for OTP step
        toast.success('OTP sent to your email');
        navigate('/user/verify-otp');
      } else {
        toast.error('Invalid email or password');
      }
    } catch (err) {
      toast.error('Login failed. Invalid email or password.');
    } finally {
      setLoading(false);
    }
  };

  return (
  <div className="relative flex items-center justify-center min-h-screen overflow-hidden">

  {/* Toast */}
   {/* <ToastContainer
                       position="bottom-left"
                       autoClose={5000}
                       hideProgressBar={true}
                       newestOnTop={false}
                       closeOnClick
                       rtl={false}
                       pauseOnFocusLoss
                       draggable
                       pauseOnHover
                       theme="dark"
                       className="!mb-6 !ml-4"
                       toastClassName="!inline-flex !items-center !whitespace-nowrap !bg-black !text-white !px-4 !py-2 !rounded-lg !w-auto !min-w-0 !shadow-lg"
                     /> */}

    {/* Background Image */}
    <div className="absolute inset-0">
      <img
        src={illustration}
        alt="bg"
        className="object-cover w-full h-full scale-70 "
      />
      <div className="absolute inset-0 bg-black/40"></div>
    </div>

   

    {/* Right Side Sliding Form */}
    <div className="relative z-10 flex justify-end w-full">

      <div className="w-full max-w-md p-6 m-0 transition-all duration-700 ease-out transform bg-white rounded-md shadow-2xl lg:m-10 animate-slideInRight">

        <h2 className="flex items-center justify-center mb-2 text-3xl font-extrabold text-gray-900">
  <img
    src={Logo}
    alt="bg"
    className="object-cover scale-110 h-14 w-14"
  />
</h2>

        <p className="mb-6 font-sans text-sm font-medium text-center text-gray-800">
          Login to Practical Infosec EdTech Platform
        </p>

        <form onSubmit={handleSubmit} className="space-y-6">

          {/* Email */}
          <div>
            <label className="block mb-1 font-sans text-sm font-semibold text-gray-700">
              Email
            </label>

            <div className="relative">
              <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-gray-400">
                <MailOutlined />
              </span>

              <input
                type="email"
                name="Email"
                value={form.Email}
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder="you@example.com"
                className={`w-full pl-10 pr-4 py-3 rounded-lg border transition-all duration-200 focus:outline-none
                ${
                  !touched.Email
                    ? "border-gray-300 focus:ring-2 focus:ring-blue-500"
                    : isEmailValid
                    ? "border-green-500 focus:ring-2 focus:ring-green-500"
                    : "border-red-500 focus:ring-2 focus:ring-red-500"
                }`}
              />
            </div>
          </div>

          {/* Password */}
          <div >
            <label className="block mb-1 font-sans text-sm font-semibold text-gray-700">
              Password
            </label>

            <div className="relative">
              <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-gray-400">
                <LockOutlined />
              </span>

              <input
                type={showPassword ? "text" : "password"}
                name="Password"
                value={form.Password}
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder="••••••"
                className={`w-full pl-10 pr-10 py-3 rounded-lg border transition-all duration-200 focus:outline-none
                ${
                  !touched.Password
                    ? "border-gray-300 focus:ring-2 focus:ring-blue-500"
                    : isPasswordValid
                    ? "border-green-500 focus:ring-2 focus:ring-green-500"
                    : "border-red-500 focus:ring-2 focus:ring-red-500"
                }`}
              />

              <button
                type="button"
                onClick={() => setShowPassword((prev) => !prev)}
                className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-500"
              >
                {showPassword ? <EyeInvisibleOutlined /> : <EyeOutlined />}
              </button>
            </div>
          </div>

          {/* Forgot */}
          <div className="flex justify-end">
            <ForgotPasswordModal
              trigger={
                <Button type="link" className="text-sm font-semibold text-blue-600">
                  Forgot password?
                </Button>
              }
            />
          </div>

          {/* Button */}
          <button
            type="submit"
            disabled={loading}
            className="w-full py-3 font-semibold font-sans text-white transition-all duration-300 rounded-lg shadow-lg bg-gradient-to-r from-blue-600 to-indigo-600 hover:scale-[1.02] hover:from-blue-700 hover:to-indigo-700 disabled:opacity-50"
          >
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>

        <div className="mt-3 text-sm text-center text-gray-600">
          © {new Date().getFullYear()} Practical Infosec Pvt Ltd
        </div>
      </div>
    </div>
  </div>
);
};

export default LoginPage;
